import React from "react";
import AuthStageController from "../../../../process/authProcess/view/entries/AuthStageController";

export const AuthView = () => {
	return <AuthStageController />;
};
